// @ts-strict-ignore
/**
 * FX HedgePool Inc. Proprietary and Confidential
 *
 * This source code and the algorithms implemented herein are the sole property of FX HedgePool, Inc.,
 * are confidential information, and are trade secrets of FX HedgePool, Inc.
 * Redistribution or use of this source code or the algorithms implemented herein, in whole or in part,
 * without the express written permission of FX HedgePool, Inc. is strictly prohibited.
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'spinner-modal',
  templateUrl: './spinner-modal.component.html',
  styleUrl: './spinner-modal.component.scss',
})
export class SpinnerModalComponent implements OnInit, OnDestroy {
  public subscription: Subscription;
  private pageClosed = new Subject<void>();
  public showSpinner = false;
  public showSpinnerBackdrop = false;
  constructor(public notificationsService: NotificationsService) {}

  ngOnInit(): void {
    this.subscription = this.notificationsService.spinnerSubject
      .pipe(takeUntil(this.pageClosed))
      .subscribe((val) => {
        this.showSpinner = val.showSpinner;
        this.showSpinnerBackdrop = val.showSpinnerBackdrop;
      });
  }

  public ngOnDestroy(): void {
    this.pageClosed.next();
    this.pageClosed.complete();
  }
}
